import React from "react";

import { LineupPlayer } from "../types";
import {
  formatBattingRate,
  formatCountingStat,
} from "../../../shared/utils/formatters";

interface LineupTableProps {
  teamName: string;
  lineup: LineupPlayer[];
}

/**
 * Displays a team's starting lineup with season-to-date batting stats.
 * Shows batting order position, player name, and key offensive categories.
 */
export function LineupTable({ teamName, lineup }: LineupTableProps): JSX.Element {
  if (lineup.length === 0) {
    return (
      <div className="lineup-section">
        <h4 className="lineup-section-title">{teamName}</h4>
        <p className="lineup-unavailable">Lineup not yet available</p>
      </div>
    );
  }

  return (
    <div className="lineup-section">
      <h4 className="lineup-section-title">{teamName}</h4>
      <div className="lineup-table-wrap">
        <table className="lineup-table" aria-label={`${teamName} starting lineup`}>
          <thead>
            <tr>
              <th className="col-slot">#</th>
              <th className="col-name">Batter</th>
              <th className="col-stat">AVG</th>
              <th className="col-stat">OBP</th>
              <th className="col-stat">SLG</th>
              <th className="col-stat">OPS</th>
              <th className="col-stat">HR</th>
              <th className="col-stat">RBI</th>
              <th className="col-stat">H</th>
              <th className="col-stat">BB</th>
              <th className="col-stat">K</th>
            </tr>
          </thead>
          <tbody>
            {lineup.map((player) => {
              const s = player.season_to_date_batting;
              return (
                <tr key={player.player_id}>
                  <td className="col-slot">{player.batting_order_slot}</td>
                  <td className="col-name">{player.player_name ?? "Name unavailable"}</td>
                  <td className="col-stat">{formatBattingRate(s?.avg ?? null)}</td>
                  <td className="col-stat">{formatBattingRate(s?.obp ?? null)}</td>
                  <td className="col-stat">{formatBattingRate(s?.slg ?? null)}</td>
                  <td className="col-stat">{formatBattingRate(s?.ops ?? null)}</td>
                  <td className="col-stat">{formatCountingStat(s?.home_runs ?? null)}</td>
                  <td className="col-stat">{formatCountingStat(s?.rbi ?? null)}</td>
                  <td className="col-stat">{formatCountingStat(s?.hits ?? null)}</td>
                  <td className="col-stat">{formatCountingStat(s?.base_on_balls ?? null)}</td>
                  <td className="col-stat">{formatCountingStat(s?.strike_outs ?? null)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
